export default __webpack_public_path__ + "static/media/rathe-holdings-image.54d25b29.jpg";